export const CREATE_USER = 'CREATE_USER'
export const PASSCODE = 'PASSCODE'
export const RESET_USER = 'RESET_USER'
export const SET_USER = 'SET_USER'
export const SET_USERS = 'SET_USERS'
export const USER = 'USER'
export const USER_COLORS = ['#D2CAEE', '#BECFF4', '#F4E0BE', '#D8E5CA', '#CAE5E1']
export const USERS = 'USERS'
